import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import DOMPurify from 'dompurify';

@Injectable()
export class UserCacheService {
  private static instanceCounter = 0;
  private renderer: Renderer2;
  private eeaUserCacheMap: any;
  private readonly instanceId: number;
  constructor(private rendererFactory: RendererFactory2) {
    this.instanceId = ++UserCacheService.instanceCounter;
    this.renderer = rendererFactory.createRenderer(null, null);
    this.eeaUserCacheMap = {};
    this.loadFromLocalStorage();
  }

  /**
   * This function checks the local storage for any offloaded data for this cache.
   * This function is to ensure that refreshing the page will not ruin our chache.    
   */
  loadFromLocalStorage() {
    const localUserCache = localStorage.getItem('localSAEUserCache');
    if (localUserCache != undefined && localUserCache != null) {
      const localUserCacheSanitize = DOMPurify.sanitize(localUserCache);
      this.eeaUserCacheMap = JSON.parse(localUserCacheSanitize);
      localStorage.removeItem('localSAEUserCache');
    }
  }

  /**
   * Helper function that offloads data to the localStorage. This is triggered
   * On page refreshes to prevent the cache from breaking on refresh.
   */
  backupToLocalStorage() {
    localStorage.setItem('localSAEUserCache', JSON.stringify(this.eeaUserCacheMap));
  }

  /**
   * This function is used to get data from the cache.
   * @param key {String} - The map key that our desired data should be housed at
   */
  getUserData(key: string): any {
    return this.eeaUserCacheMap[key];
  }

  /**
   * This function is used to save data in the cache.
   * @param key {String} - The map key that our data should be housed at
   * @param data {any} - The data to save
   */
  setUserData(key: string, data: any): void {
    this.eeaUserCacheMap[key] = data;
  }

  /**
   * This function is used to erase data from the cache.
   * @param key {String} - The map key we should erase
   */
  eraseUserData(key: string): void {
    this.eeaUserCacheMap[key] = undefined;
  }

  /**
   * This function is used to erase ALL data from the cache.
   */
  eraseAllUserData(): void {
    this.eeaUserCacheMap = {};
  }

  /**
  * This function is used to get ALL data from the cache.
  */
  getAllUserCacheData(): any {
    return this.eeaUserCacheMap;
  }

}
